import { configuration } from 'config/constants';

export type BoardName = 'contactReadership';

export type SelectorName = 'icSingleContactPicker' | 'icMultiContactPicker';

export interface SGDashboard {
    url: string;
    boards: Record<BoardName, number>;
    selectors: Record<SelectorName, number>;
}

export interface Selector {
    id: number;
    properties: { name: string; value: string | string[] }[];
}

export const buildBoardUrlByConfig = (contactIcId: string) => {
    const sgDashboardConfig = configuration.externalLinks.sgDashboard;

    const selectors: Selector[] = Object.keys(sgDashboardConfig.selectors).map(
        x => ({
            id: sgDashboardConfig.selectors[x as SelectorName],
            properties: [{ name: 'selectedIds', value: [contactIcId] }],
        }),
    );

    const details = selectors.reduce((acc, cur) => {
        const inputs = cur.properties.reduce(
            (innerAcc, innerCur) => ({
                ...innerAcc,
                [`${innerCur.name}`]: innerCur.value,
            }),
            {},
        );
        return { ...acc, [`${cur.id}`]: { inputs } };
    }, {});

    const selectorsConfig = { selectors: details };
    const urlFragment = btoa(JSON.stringify(selectorsConfig));

    return `${sgDashboardConfig.url}/explore/boards/${sgDashboardConfig.boards.contactReadership}?configuration=${urlFragment}`;
};
